const LOGIN_PATHS = new Set(['/login', '/admin/login', '/account/signin']);

/** 클릭/입장 시 로그인 안내가 필요한 경로 (페이지 자동 이동 없음) */
export const LOGIN_GATE_PATHS = new Set(['/chat', '/shop']);

export function isLoginPath(pathname: string): boolean {
  return LOGIN_PATHS.has(pathname);
}

export function isLoginGatePath(pathname: string): boolean {
  if (LOGIN_GATE_PATHS.has(pathname)) {
    return true;
  }

  return pathname.startsWith('/chat/room/') || pathname.startsWith('/shop/');
}

/** 로그인 redirect 파라미터에서 중첩 /login 루프를 제거합니다. */
export function sanitizeLoginRedirect(raw: string | null | undefined, fallback = '/'): string {
  let current = String(raw ?? '').trim();
  if (current === '') {
    return fallback;
  }

  for (let depth = 0; depth < 6; depth += 1) {
    let decoded = current;
    try {
      decoded = decodeURIComponent(current);
    } catch {
      return fallback;
    }

    if (!decoded.startsWith('/') || decoded.startsWith('//')) {
      return fallback;
    }

    const queryIndex = decoded.indexOf('?');
    const pathOnly = queryIndex === -1 ? decoded : decoded.slice(0, queryIndex);
    const query = queryIndex === -1 ? '' : decoded.slice(queryIndex + 1);

    if (isLoginPath(pathOnly)) {
      const nested = new URLSearchParams(query).get('redirect');
      if (nested) {
        current = nested;
        continue;
      }
      return fallback;
    }

    return decoded;
  }

  return fallback;
}

export function buildLoginPath(redirectPath: string, reason?: string): string {
  const safeRedirect = sanitizeLoginRedirect(redirectPath, '/');
  const params = new URLSearchParams();
  if (safeRedirect && safeRedirect !== '/') {
    params.set('redirect', safeRedirect);
  }
  if (reason) {
    params.set('reason', reason);
  }
  const qs = params.toString();
  return qs ? `/login?${qs}` : '/login';
}

/** 브라우저 주소창에 중첩 redirect 가 있으면 정리합니다. */
export function normalizeLoginPageUrl(): void {
  if (typeof window === 'undefined' || !isLoginPath(window.location.pathname)) {
    return;
  }

  const params = new URLSearchParams(window.location.search);
  const rawRedirect = params.get('redirect');
  const safeRedirect = sanitizeLoginRedirect(rawRedirect, '/');
  const reason = params.get('reason') === 'session_expired' ? 'session_expired' : '';

  const needsCleanup =
    (rawRedirect && rawRedirect !== safeRedirect)
    || window.location.search.includes('%2Flogin')
    || params.getAll('reason').length > 1;

  if (!needsCleanup) {
    return;
  }

  const next = new URLSearchParams();
  if (safeRedirect && safeRedirect !== '/') {
    next.set('redirect', safeRedirect);
  }
  if (reason) {
    next.set('reason', reason);
  }
  const qs = next.toString();
  window.history.replaceState({}, '', qs ? `/login?${qs}` : '/login');
}
